export default __webpack_public_path__ + "static/media/M1A_4.c4fe5e3e.png";